import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { useSelector } from 'react-redux'
import PrintableInvoice from 'components/generic/printable/PrintableInvoice'

const InvoicePrintModal = ({ onFormStateChange }) => {
  const {
    invoiceData,
    selectedOutboundTickets,
    salesOrderData,
    customerData,
    priceSheetsData,
    priceSheet,
    summaryData,
    totalAmountPaid,
    pricePrepend = '$',
  } = useSelector(state => state.ui.formModalProps)

  useEffect(() => {
    onFormStateChange(false)
  }, [])

  return (
    <PrintableInvoice
      invoiceData={invoiceData}
      selectedOutboundTickets={selectedOutboundTickets}
      salesOrderData={salesOrderData}
      customerData={customerData}
      priceSheetsData={priceSheetsData}
      invoicePaymentData={{}}
      priceSheet={priceSheet}
      summaryData={summaryData}
      totalAmountPaid={totalAmountPaid}
      pricePrepend={pricePrepend}
    />
  )
}

InvoicePrintModal.propTypes = {
  onFormStateChange: PropTypes.func,
}

InvoicePrintModal.defaultProps = {
  onFormStateChange: noop,
}

export default InvoicePrintModal
